import { render, staticRenderFns } from "./visitedForm.vue?vue&type=template&id=4ec754da&scoped=true"
import script from "./visitedForm.vue?vue&type=script&lang=js"
export * from "./visitedForm.vue?vue&type=script&lang=js"
import style0 from "./visitedForm.vue?vue&type=style&index=0&id=4ec754da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec754da",
  null
  
)

export default component.exports